import React from 'react';

import PageTitle from '../../../common/PageTitle';
import Table from '../../../common/Table';
import styled from '@emotion/styled';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  .shortname-td {
    color: #343a40;
    font-weight: bold;
    max-width: 300px;
    .ids-span {
      font-size: 11px;
      color: #98a6ad;
      cursor: pointer;
      font-weight: normal;
    }
  }

  .shortname-link {
    cursor: pointer;
    color: #7e57c2;

    &:hover {
      color: #593696;
    }
  }
`;

const DesktopComponent = ({
  tableData,
  loading,
  total,
  handleSearch,
  handleNewItem,
  handleCopyItem,
  handleRemoveItem,
  handleChangePage,
  handleUnloadingSetOfGoodsChestnyznak,
}) => {
  const { t } = useAutoTranslation();

  return (
    <>
      <PageTitle title={t('Комплекты')} />

      <Wrapper className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <Table
                data={tableData}
                createLabel={t('Новое задание')}
                searchable
                creatable
                copyable
                removable
                pagination
                perPage={10}
                loading={loading}
                totalItems={total}
                handleSearch={handleSearch}
                handleNewItem={handleNewItem}
                handleCopyItem={handleCopyItem}
                handleRemoveItem={handleRemoveItem}
                handleChangePage={handleChangePage}
                handleUnloadingSetOfGoodsChestnyznak={handleUnloadingSetOfGoodsChestnyznak}
                id={'physicalSetsJournal'}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default DesktopComponent;
